module.exports = __webpack_public_path__ + "img/google-play.7ab3234c.png";